import { getValueAsPercentage } from "util/number-utils";

export const renderCues = (options: {
    canvas: HTMLCanvasElement;
    width: number;
    height: number;
    inPoint: number;
    outPoint: number;
    cues: { startTime: number; endTime: number }[];
    playbackStartTime: number;
}) => {
    const {
        canvas,
        width,
        height,
        inPoint,
        outPoint,
        cues,
        playbackStartTime
    } = options;
    const ctx = canvas.getContext(`2d`);
    const playbackInPointMs = inPoint * 1000 - playbackStartTime;
    const playbackOutPointMs = outPoint * 1000 - playbackStartTime;
    const duration = playbackOutPointMs - playbackInPointMs;

    //TODO: this should be a config
    ctx.fillStyle = `#596281`;
    ctx.strokeStyle = `#8983ff`;

    ctx.fillRect(0, 0, width, height);
    cues.forEach((cue) => {
        if (
            playbackInPointMs < cue.endTime &&
            playbackOutPointMs > cue.startTime
        ) {
            const pathEnd = getValueAsPercentage(cue.endTime, duration, width);
            const pathStart = getValueAsPercentage(
                cue.startTime,
                duration,
                width
            );
            const y = height / 2;

            ctx.beginPath();
            ctx.moveTo(pathStart, y - 2.5);
            ctx.lineTo(pathStart, y + 2.5);
            ctx.stroke();

            ctx.moveTo(pathStart, y);
            ctx.lineTo(pathEnd, y);
            ctx.stroke();

            ctx.moveTo(pathEnd, y - 2.5);
            ctx.lineTo(pathEnd, y + 2.5);
            ctx.stroke();
            ctx.closePath();
        }
    });
};
